<script lang="tsx">
import {
  Back,
  Delete,
  Plus,
  Refresh,
  Right,
  Search,
} from '@element-plus/icons-vue'
import GoodsUploadImageManage from "~/components/common/GoodsUploadImageManage/index.vue";
import {
  defineComponent,
  reactive,
  UnwrapNestedRefs
} from 'vue'
 
import {
  ElButton,
} from 'element-plus'
import { $t } from  "~/utils/index.js";

export default defineComponent({
  name: 'GoodsImageItem',
  components: {
    GoodsUploadImageManage,
    Delete,
    Search,
    Refresh,
    Plus,
  },
  props: {
    uploadStyle: {
      type: String,
      default: 'image',
    },
    previewSrcList: {
      type: Array,
      default: () => [],
    },
    initialIndex: {
      type: Number,
      default: -1,
    },
    previewImage: {
      type: Boolean,
      default: false,
    },
    move: {
      type: Boolean,
      default: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    viewSizes: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      default: '',
    },
    labelText: {
      type: String,
      default: '',
    },
    moveLeftIcon: {
      type: [String, Object],
      default: Back,
    },
    moveRightIcon: {
      type: [String, Object],
      default: Right,
    },
  },
  setup(props: any, ctx: any) {
    const state: UnwrapNestedRefs<any> = reactive({
      dialogVisible: false,
      selectType: $t('actions.选中前9张'),
      viewLargeImage: true,
      selectTypeVal: true,
      viewImageSize: true,
      sizes: null,
      selectImages: [],
      images: [],
    })
    const refs: any = {}
    const setRef = (el: any, key: string) => {
      refs[key] = el
    }
    function isVideo(url: any): boolean {
      const ext = url.split('.').pop().toLowerCase()
      const videoExtensions = [
        'mp4',
        'webm',
        'avi',
        'mov',
        'wmv',
        'flv',
        'mkv',
      ]
      return videoExtensions.includes(ext)
    }
    function onImgLoad(e: any) {
      console.log('onImgLoad', e)
      if (e && e.target && e.target.naturalWidth) {
        state.sizes = {
          width: e.target.naturalWidth,
          height: e.target.naturalHeight,
        }
      }
    }
    function onViewImage() {
      if (refs.elImgRef && refs.elImgRef.$el) {
        refs.elImgRef.$el.querySelector('img').click()
      }
    }

    function onToggleCheckedClick() {
      ctx.emit('check-change', props.url, !props.checked)
    }
    function onLeftClick() {
      ctx.emit('move', props.initialIndex, -1)
    }
    function onRightClick() {
      ctx.emit('move', props.initialIndex, 1)
    }
    function onRefreshClick() {}
    function onImageEditorClick() {
      // ctx.emit("check-change", props.url, !props.checked);
    }
    function onRemoveClick() {
      ctx.emit('remove', props.initialIndex)
    }
    function onUploadChange(v: any) {
      ctx.emit('uploading-change', v)
    }
    function onUploadSuccess(url: any) {
      ctx.emit('change', props.initialIndex, url)
    }

    function onZoneSelected(urls: any[]) {
      ctx.emit('change', props.initialIndex, urls[urls.length - 1])
    }
    return {
      setRef,
      state,
      onToggleCheckedClick,
      onImgLoad,
      onViewImage,
      onLeftClick,
      onRightClick,
      onRefreshClick,
      onImageEditorClick,
      onUploadSuccess,
      onZoneSelected,
      onUploadChange,
      onRemoveClick,
      isVideo,
    }
  },
})
</script>

<template>
  <div
    class="picture-item image-item" :class="{
      'is-selected': checked,
    }"
  >
    <el-popover
      v-if="url"
      :disabled="!previewImage"
      placement="left-start"
      :width="300"
      trigger="hover"
    >
      <el-image :src="url" />
      <template #reference>
        <div class="picture-item-box" @click="onToggleCheckedClick" />
      </template>
    </el-popover>

    <template v-if="uploadStyle === 'image'">
      <el-image
        v-if="url"
        :ref="(e:any) => setRef(e, 'elImgRef')"
        class="img-box"
        loading="lazy"
        preview-teleported
        :initial-index="initialIndex"
        :preview-src-list="previewSrcList"
        :src="url"
        @load="onImgLoad"
      />
      <GoodsUploadImageManage
        v-else
        :upload-style="uploadStyle"
        @uploading-change="onUploadChange"
        @upload-success="onUploadSuccess"
        @zone-selected="onZoneSelected"
        @add-link-images="onZoneSelected"
      >
        <div class="el-image" style="display: flex; align-items: center; justify-content: center;">
          <el-icon :size="20"><Plus /></el-icon>
        </div>
      </GoodsUploadImageManage>
    </template>
    <a
      v-else-if="uploadStyle == 'file' && isVideo(url)"
      :href="url"
      target="_BLANK"
    >
      <video class="video-play-item" :src="url" />
    </a>
    <el-image
      v-else
      :ref="(e:any) => setRef(e, 'elImgRef')"
      class="img-box"
       :preview-src-list="previewSrcList"
      :src="url"
    />
    <div v-if="checked" class="picture-flag" />

    <div class="picture-item-sidebar">
      <div class="picture-item-sidebar-icon" @click="onViewImage">
        <el-icon><Search /></el-icon>
      </div>
    </div>
    <div v-if="viewSizes && state.sizes" class="picture-size-bar">
      {{ state.sizes.width }} x {{ state.sizes.height }}
    </div>
    <div v-if="labelText" class="picture-label-bar">
      {{ labelText }}
    </div>

    <el-button-group class="custom-button-group picture-item-footer">
      <el-button v-if="move" @click="onLeftClick" :icon="moveLeftIcon" />
      <el-button v-if="move" @click="onRightClick" :icon="moveRightIcon" />
      <GoodsUploadImageManage
        :upload-style="uploadStyle"
        @uploading-change="onUploadChange"
        @upload-success="onUploadSuccess"
        @zone-selected="onZoneSelected"
        @add-link-images="onZoneSelected"
      >
        <el-button>
          <el-icon><Refresh /></el-icon>
        </el-button>
      </GoodsUploadImageManage>
      <!-- <el-button @click="onImageEditorClick">
        <el-icon><Picture /></el-icon>
      </el-button> -->
      <el-button @click="onRemoveClick">
        <el-icon><Delete /></el-icon>
      </el-button>
    </el-button-group>
  </div>
</template>

<style lang="scss" scoped>
.image-item {
  margin: 3px;
  display: inline-block;
  position: relative;
}

.image-item .add-image-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  color: #ccc;
  font-size: 30px;
  cursor: pointer;
  background: #fff;
}

.image-item .add-image-box-footer {
  width: 100%;
  text-align: center;
  background: #f9f9f9;
  color: #aaa;
  font-size: 13px;
  line-height: 24px;
}

.common-btn,
.image-translate-btn .el-button {
  margin-left: 10px;
  margin-bottom: 10px;
}

.picture-item {
  cursor: pointer;
  position: relative;
  border: 2px solid rgba(0, 0, 0, 0);
  display: inline-block;
  overflow: hidden;
}

.picture-item.is-idle {
  pointer-events: none;
}

.picture-item.is-selected {
  border-color: var(--el-color-primary);
}

.picture-item.is-error {
  border-color: red;
}

.picture-item.is-disabled {
  pointer-events: none;
}
.picture-item-box {
  position: absolute;
  left: 100%;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 25px;

  z-index: 1111;
}
.picture-item:hover {
  .picture-item-box {
    left: 0;
  }
}
.picture-item.translate-loading:after {
  content: "翻译中...";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #fff;
  font-size: 12px;
}

.picture-item .img-box {
  display: block;
}

.video-play-item {
  width: 120px;
  height: 120px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  background: #fff;
  display: block;
}
.picture-item .el-image {
  width: 120px;
  height: 120px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  background: #fff;
  display: block;
}

.picture-item:hover .picture-item-sidebar {
  transform: scaleX(1);
}

.picture-item-sidebar {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 24px;
  right: 0;
  transform: scaleX(0);
  transition: all 0.3s;
  transform-origin: right;
  font-size: 16px;

  z-index: 1112;
}

.picture-item-sidebar .picture-item-sidebar-icon {
  margin-top: 5px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: var(--el-color-primary);
  color: #fff;
}

.recovery-picture-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
}

.picture-size-bar {
  position: absolute;
  left: 0;
  bottom: 24px;
  background: hsla(0, 0%, 100%, 0.8);
  box-sizing: border-box;
  padding: 0 5px;
  font-size: 14px;
}
.picture-label-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 24px;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  box-sizing: border-box;
  padding: 0 5px;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.picture-flag {
  position: absolute;
  left: 0;
  top: 0;
  border-top: 20px solid var(--el-color-primary);
  border-right: 20px solid transparent;
}

.picture-flag-error {
  border-top: 20px solid red;
}

.clean-img-tag {
  position: absolute;
  background-color: var(--el-color-primary);
  color: #fff;
  top: 0;
  left: 0;
  line-height: 14px;
  font-size: 12px;
  padding: 2px 5px;
  z-index: 2;
}

.translate-icon {
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 20px;
  cursor: pointer;
  font-weight: 700;
  background-color: #fff;
  border-radius: 50%;
  z-index: 1;
  pointer-events: auto;
}

.picture-item-footer {
  display: flex;
}

.picture-item-footer :deep( .el-button ) {
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex: 1;
  margin: 0;
}

.picture-item-footer .el-button i {
  font-weight: 700;
  font-size: 14px;
  display: block;
}

.clean-image {
  font-size: 14px;
}

.spot-img-tag {
  position: absolute;
  background-color: #909399;
  color: #fff;
  top: 0;
  left: 0;
  line-height: 14px;
  font-size: 12px;
  padding: 2px 5px;
  z-index: 2;
}
</style>
